export default __webpack_public_path__ + "static/media/icon_experience.8d03e0d9.svg";